// Persist an in-progress practice session so a reload or back-navigation is
// resumable instead of destructive. One slot per context key; saved sessions
// expire after MAX_AGE_MS so a stale set doesn't resurface days later.
const PREFIX = 'speaksaigon_session_'
export const MAX_AGE_MS = 24 * 60 * 60 * 1000

// The demo is a throwaway taste — never persisted (returns null).
export function sessionKey({ demoMode, reviewMode, mistakesMode, level, unitId }) {
  if (demoMode) return null
  if (mistakesMode) return `${PREFIX}mistakes`
  if (reviewMode) return `${PREFIX}review-${level}`
  return `${PREFIX}unit-${unitId}`
}

export function saveSession(key, state) {
  if (!key) return
  try {
    localStorage.setItem(key, JSON.stringify({ ...state, savedAt: Date.now() }))
  } catch (e) { /* storage full / private mode — resume is best-effort */ }
}

export function loadSession(key) {
  if (!key) return null
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return null
    const state = JSON.parse(raw)
    if (!state || !Array.isArray(state.exercises) || !state.exercises.length) return null
    if (Date.now() - (state.savedAt || 0) > MAX_AGE_MS) {
      localStorage.removeItem(key)
      return null
    }
    return state
  } catch (e) {
    return null
  }
}

export function clearSession(key) {
  if (!key) return
  try { localStorage.removeItem(key) } catch (e) { /* ignore */ }
}
